import { memo } from 'react'
import { SxProps } from '@mui/material'
import clsx from 'clsx'
import { StarIcon } from '@/assets'
import { Box } from '@/components/Layout'
import {
  starRatingClasses as classes,
  starRatingStyles as styles,
  getStarSizeSx,
} from './StarRating.style'
import { StarRatingProps } from './StarRating.types'

const MAX_RATING = 5
const DEFAULT_SIZE = 24

function StarRating({
  rating,
  size = DEFAULT_SIZE,
  sx,
  className,
  starProps = {},
  ...props
}: StarRatingProps) {
  const { className: starClassName, ...otherStarProps } = starProps

  return (
    <Box
      sx={[styles.root, getStarSizeSx(size), sx] as SxProps}
      className={clsx(classes.root, className)}
      {...props}>
      {Array.from({ length: MAX_RATING }, (_, index) => (
        <StarIcon
          key={index}
          className={clsx(
            classes.star,
            index < rating ? classes.filled : classes.empty,
            starClassName,
          )}
          {...otherStarProps}
        />
      ))}
    </Box>
  )
}

export default memo(StarRating)
